import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CreateDeviceDialogComponent } from 'app/dialogs/create-device-dialog/create-device-dialog.component';
import { DeviceDeliveryDialogComponent } from 'app/dialogs/device-delivery-dialog/device-delivery-dialog.component';
import { UpdateDeviceDialogComponent } from 'app/dialogs/update-device-dialog/update-device-dialog.component';
import { BrandService } from 'app/services/models/brand.service';
import { CompanyService } from 'app/services/models/company.service';
import { DeviceService } from 'app/services/models/device.service';
import { KindService } from 'app/services/models/kind.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-device-list',
  templateUrl: './device-list.component.html',
  styleUrls: ['./device-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DeviceListComponent implements OnInit {
  @ViewChild('table') tableRowDetails: any;

  constructor(
    private deviceService: DeviceService,
    private router: Router,
    private modalService: NgbModal,
    private kindSerivce: KindService,
    private brandService: BrandService,
    private companyService: CompanyService,
    private kindService: KindService
  ) { }

  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  public searchValue = '';
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;

  async ngOnInit() {
    this.deviceService.event$.subscribe(async result => {
      await this.getAllDevice(this.pageBasic - 1, this.selectedSize, this.searchValue, this.companyId, this.kindId, this.brandModelId, this.brandId);
    })
    await this.getAllDevice(this.pageBasic - 1, this.selectedSize, this.searchValue, this.companyId, this.kindId, this.brandModelId, this.brandId);
    await this.getAllBrands();
    await this.getAllBrandModel();
    await this.getAllCompanies();
    await this.getAllKinds();
  }

  async getAllDevice(page, size, search, companyId?: number, kindId?: number, brandModelId?: number, brandId?: number) {
    this.blockUI.start("Cihazlar yükleniyor...")
    const data = await this.deviceService.getAllDevices(page, size, search, companyId, kindId, brandModelId, brandId);
    console.log(data);
    this.totalCount = data.totalCount;
    this.rows = data.devices;
    this.blockUI.stop();
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.searchValue = val;
    setTimeout(async () => {

      await this.getAllDevice(this.pageBasic - 1, this.selectedSize, this.searchValue, this.companyId, this.kindId, this.brandModelId, this.brandId);
    }, 500);
  }

  async onPageChange(pageNumber: number) {
    await this.getAllDevice(this.pageBasic - 1, this.selectedSize, this.searchValue, this.companyId, this.kindId, this.brandModelId, this.brandId);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllDevice(this.pageBasic - 1, this.selectedSize, this.searchValue, this.companyId, this.kindId, this.brandModelId, this.brandId);
  }


  onActivate(event: any) {
    if (event.type === 'click' && event.row) {
      this.router.navigate([`/admin/device/${event.row.id}`]);
    }
  }

  createDevice() {
    const modal = this.modalService.open(CreateDeviceDialogComponent, {
      size: 'lg',
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      id: null,
      companyId: null
    }
  }

  async createDeliveryDevice(kind: string) {
    const data = await this.kindSerivce.getByName(kind);
    const modal = this.modalService.open(DeviceDeliveryDialogComponent, {
      size: 'lg',
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      kindId: data.id,
      message: data.typeName,
      companyId: null
    }
  }

  updateDevice(id, event) {
    event.stopPropagation();
    const modal = this.modalService.open(UpdateDeviceDialogComponent, {
      size: 'lg',
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      id: id,
    }
  }

  searchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.name?.toLowerCase().includes(term) || item.brandName?.toLowerCase().includes(term);
  }

  async clearFilters() {
    this.brandModelId = null;
    this.brandId = null;
    this.companyId = null;
    this.kindId = null;
    await this.getAllDevice(this.pageBasic - 1, this.selectedSize, this.searchValue, this.companyId, this.kindId, this.brandModelId, this.brandId);
  }

  brandsModel: any[];
  brands: any[];
  kinds: any[];
  companies: any[];

  brandModelId = null;
  brandId = null;
  kindId = null;
  companyId = null;

  async getAllBrands() {
    const data = await this.brandService.getAllBrand(0, 1000, '');
    console.log(data);
    this.brands = data.brands;
  }

  async getAllBrandModel() {
    const data = await this.brandService.getBrands();
    console.log(data);
    this.brandsModel = data.flatMap(brand =>
      brand.brandModels.map(model => ({
        id: model.id,                // Modelin ID'sini ekliyoruz
        name: model.modelName,        // Model ismi
        brandName: brand.brandName    // Grup başlığı olarak marka ismi
      }))
    );
  }

  async getAllKinds() {
    const data = await this.kindSerivce.getAllKinds('', 0, 1000, 13)
    this.kinds = data.types;
  }

  async getAllCompanies() {
    const data = await this.companyService.getAllCompany('', 0, 10000);
    this.companies = data.companies;
  }

  async filterBrandModel(event) {
    console.log(event);
    this.brandModelId = event.id;
    await this.getAllDevice(this.pageBasic - 1, this.selectedSize, this.searchValue, this.companyId, this.kindId, this.brandModelId, this.brandId);
  }

  async filterBrand(event) {
    this.brandId = event.id;
    await this.getAllDevice(this.pageBasic - 1, this.selectedSize, this.searchValue, this.companyId, this.kindId, this.brandModelId, this.brandId);
  }

  async filterCompany(event) {
    this.companyId = event.id;
    await this.getAllDevice(this.pageBasic - 1, this.selectedSize, this.searchValue, this.companyId, this.kindId, this.brandModelId, this.brandId);
  }

  async filterKind(event) {
    await this.getAllDevice(this.pageBasic - 1, this.selectedSize, this.searchValue, this.companyId, this.kindId, this.brandModelId, this.brandId);
  }
}
